import * as React from 'react'
import { usePageDispatch, PageState } from './page.context'

export type ConfigurePageLayoutProps = Omit<PageState, 'allTypes'>

const ConfigurePageLayout: React.FC<ConfigurePageLayoutProps> = ({ children, sandboxes, sideNavs, type, slug, next, prev }) => {
  const dispatch = usePageDispatch()
  if (!dispatch) {
    throw new Error('ConfigurePageLayout must be used in child components of PageDispatchContext ')
  }
  React.useEffect(() => {
    dispatch(prevValue => ({
      ...prevValue,
      sideNavs,
      next,
      prev,
      slug,
      type,
      sandboxes,
    }))
  }, [dispatch, sideNavs, next, prev, slug, type, sandboxes])

  return <>{children}</>
}

export default ConfigurePageLayout
